import { render, staticRenderFns } from "./GarageDoorOtherDamages.vue?vue&type=template&id=5ffe7214&scoped=true"
import script from "./GarageDoorOtherDamages.vue?vue&type=script&lang=ts"
export * from "./GarageDoorOtherDamages.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ffe7214",
  null
  
)

export default component.exports